import React from "react";
import ReactPlayer from "react-player";
import { If } from "../../Generic/If";
import QuestionWrapper from "./QuestionWrapper";

const QuestionVideo = (props: { videoUrl: string }) => {
  const videoThumbnail = "https://medflyt-mobile-assets.s3.amazonaws.com/onboarding_thumbnail.png";
  return (
    <QuestionWrapper>
      <If condition={ReactPlayer.canPlay(props.videoUrl)}>
        <ReactPlayer
          url={props.videoUrl}
          width="100%"
          controls={true}
          playing={true}
          light={videoThumbnail}
        />
      </If>
    </QuestionWrapper>
  );
};

export default QuestionVideo;
